import axios from "./axiosConfig";
import { apis } from './params';

export function getQnaList(_param: any) {
    return axios({
        "method": "GET",
        "url": apis.GET_QNA_LIST + _param
    })
}

export function addUpdateAnswerCall(_param: any) {
    return axios.post(apis.ADD_UPDATE_ANSWER + _param.qId, _param)
}

export function publishQuestionsCall(_param: any) {
    return axios.post(apis.PUBLISH_QUESTIONS, _param)
}

export function disableQuestionsCall(_param: any) {
    return axios.post(apis.DISABLE_QUESTIONS, _param)
}

export function downloadQuestionsCall(_param: any) {
    return axios.get(apis.DOWNLOAD_QUESTIONS + _param)
}

// @@ AI-COMMENT: Sends CSV file as multipart form-data to the bulk insert Q&A endpoint
export function bulkInsertQACall(_param: any) {
    return axios.post(apis.BULK_INSERT_QA, _param, {
        headers: { 'Content-Type': 'multipart/form-data' }
    })
}

// @@ AI-COMMENT: Sends CSV of qIds as multipart form-data to the bulk publish endpoint
export function bulkPublishQACall(_param: any) {
    return axios.post(apis.BULK_PUBLISH_QA, _param, {
        headers: { 'Content-Type': 'multipart/form-data' }
    })
}